import { AccordionManager } from './AccordionManager';
import { clickManager } from "./clickManager";
import { KbCookiebar } from "./kb-cookiebar";
import { Menu } from "./menu";
import { ScrollFilterManager } from "./ScrollFilterManager";
import { StickyManager } from "./StickyManager";
import { UnrollerManager } from "./UnrollerManager";
import {GaEventManager} from "./GaEventManager";

document.addEventListener("render-event", () => {
  let cookiebar: KbCookiebar = new KbCookiebar();
  let clickmanager: clickManager = new clickManager();
  const accordionManager = new AccordionManager();
  const scrollFilterManager = new ScrollFilterManager();
  const stickyManager = new StickyManager();
  const unrollerManager = new UnrollerManager();
  const gaEventManager = new GaEventManager();

  let menu: Menu = new Menu();
  menu.init();

  window.cookieBar = cookiebar;
  window.gaEventManager = gaEventManager;
});
